import React, { useEffect, useState, useRef } from 'react';
import { InputItem, Picker, List, Modal, Toast, Menu } from 'antd-mobile';
import provinceData from '../province';
import ModalContent from '../component/modal/modal';
import TitleComponent from '../component/title/title';
import ImagePicker from '../../component/image-picker/index';
import { ApiCore } from '../../api';
import styles from './assistantComplete.module.scss';
import OSS from "ali-oss";
import { Button } from 'antd-mobile-v5'
import utils from '../../utils/utils';

const api = new ApiCore();

function DoctorComplete(props: any) {

    const [provinceName, setProvinceName] = useState<any>([]);
    // 城市
    const [cityName, setCityName] = useState<any>([]);
    // 真实姓名
    const [realName, setRealName] = useState<any>('');
    // 是否配置区域
    const [isArea, setIsArea] = useState<any>(false);
    // 区域列表
    const [areaList, setAreaList] = useState<any>([]);
    // 省市级
    const [provinceLevel, setProvinceLevel] = useState<any>('');
    // 城市级
    const [cityLevel, setCityLevel] = useState<any>('');
    // 性别
    const [sex, setSex] = useState([]);
    // 助理类型
    const [assistant, setAssistant] = useState([]);
    // 性别
    const [sexList, setSexList] = useState([
        {
            label: '男',
            value: '0',
        },
        {
            label: '女',
            value: '1',
        }
    ]);
    // 助理类型
    const [assistantList, setAssistantList] = useState([]);

    useEffect(() => {
        //设置网页title
        document.title = '完善信息';
        initData();
        return () => {
        }
        
    }, [props])

    const initData = () => {
        api.getVisitAssistantRoleList().then((res: any) => {
            if (res.code == 0) {
                let _data = res.data || [];
                const _list = _data.map((val: any) => {
                    return {
                        label: val.name,
                        value: val.code
                    }
                });
                setAssistantList(_list);
            }
        });
    }

    // 省份
    const onProvince = (value: any) => {
        setProvinceName(value)
        setCityName([])
    }

    const onAssistant = (value: any) => {
        setAssistant(value);
    }

    const onSex = (value: any) => {
        setSex(value);
    }

    // 城市
    const onCity = (value: any) => {
        setCityName(value)
    }

    // 真实姓名
    const onRealName = (value: any) => {
        setRealName(value)
    }

    // 数据 
    const dataList = [
        { key: 'InputItem', label: '姓名', type: 'text', placeholder: '请填写您的真实姓名', maxLength: 50, value: realName, onChange: (v: any) => onRealName(v), required: true },
        { key: 'Picker-sex', label: '性别', type: '', placeholder: '请选择您的性别', maxLength: 50, value: realName, onChange: (v: any) => onSex(v), required: true },
        { key: 'Picker-province', label: '省份', type: '', isHidden: (isArea && provinceLevel == null) ? true : false, placeholder: '请选择您所在的省份', maxLength: '', value: provinceName, onChange: (v: any) => onProvince(v), required: true },
        { key: 'Picker-city', label: '城市', type: '', 
        disabled: !isArea ? (provinceName && provinceName.length == 0 ? true : false) : (provinceLevel == null ? false : true),
        isHidden: (isArea && cityLevel == null) ? true : false, placeholder: '请填写您所在的城市', maxLength: '', value: cityName, onChange: (v: any) => onCity(v), required: true },
        { key: 'Picker-assistant', label: '助理类型', type: '', placeholder: '请选择您的助理类型', maxLength: 50, value: realName, onChange: (v: any) => onAssistant(v), required: true }
    ]

    // 默认城市联动
    const defultCityData = () => {
        let data: any = []
        provinceData.find((i: any) => {
            if (i.value == provinceName) {
                data = i.children
            }
        })
        return data
    }

    // 配置城市联动
    const configCityData = () => {
        let childrenData: any = []
        if (areaList && areaList.length > 0) {

            areaList.find((i: any) => {
                if (i.areaName == provinceName) {
                    childrenData = i.childrenAreaList
                }
            })

            if (childrenData && childrenData.length > 0) {
                childrenData.map((item: any) => {
                    item['label'] = item.areaName
                    item['value'] = item.areaName
                })
            }
        }
        return childrenData;
    }

    const toNavigateBack = () => {
        if (utils.isMiniProgram()) {
            (window as any).wx.miniProgram.navigateBack({
              delta: 1,
              success: function (e: any) {
              },
              fail: function (e: any) {
              }
            })
          } 
    }

    const submitData = () => {
        if (!realName) {
            Toast.info('请输入您的真实姓名', 0.8);
            return;
        }
        if (!sex[0]) {
            Toast.info('请选择性别', 0.8);
            return;
        }
        if (!provinceName[0]) {
            Toast.info('请选择省份', 0.8);
            return;
        }
        if (!cityName[0]) {
            Toast.info('请选择城市', 0.8);
            return;
        }
        if (!assistant[0]) {
            Toast.info('请选择助理类型', 0.8);
            return;
        }
        const _param: any = {
            name: realName,
            city: cityName[0] || '',
            province: provinceName[0] || '',
            sex: sex[0] || '',
            // type: assistant[0] || ''
            assistantType: assistant[0] || ''
        };
        const urlParams = utils.getUrlParams() || {};
        const groupCode = urlParams.groupCode || '';
        if (groupCode) {
            _param.groupCode= groupCode;
        }
        // api.toAssistantPerfectInfo(_param).then((res: any) => {
        api.toVisitRegisterAdd(_param).then((res: any) => {
            if (res.code == 0) {
                Toast.info('保存成功');
                if (res.data?.state == 2) {
                    props.history.push('/doctor/home');
                } else {
                    props.history.push('/pfizer/auditComplete');
                }
            } else {
                Toast.info(res.message || '保存失败');
            }
        });
    }

    return (
        <div className={styles.medicalAssistant}>
            <div className={styles.doctor_info}>
                <TitleComponent title={'完善您的个人信息'} subTitle={'请填写您的相应信息'} />
                {
                    dataList.map((item: any, index: any) => (
                        <div className={`${styles.InputItemContent} ${styles.provinceWrap} ${item.required ? styles.required : ''}`} key={index}>
                            <label className={styles.label}>
                                {
                                    item.isHidden && (item.key == 'Picker-city' || item.key == 'Picker-province')  ? '' : item.label
                                }
                            </label>
                            {item.key == 'InputItem' &&
                                <InputItem
                                    type={item.type}
                                    placeholder={item.placeholder}
                                    maxLength={item.maxLength}
                                    value={item.value}
                                    onChange={item.onChange}
                                />}

                            {item.key == 'Picker-province' &&
                                <div hidden={item.isHidden}>
                                    <Picker
                                        data={areaList.length == 0 ? provinceData : areaList}
                                        cols={1}
                                        className="forss"
                                        value={provinceName}
                                        onChange={(v: any) => onProvince(v)}
                                    >
                                        <List.Item
                                            arrow={'horizontal'}
                                            extra={item.placeholder}
                                        ></List.Item>
                                    </Picker>
                                </div>
                            }

                            {item.key == 'Picker-city' &&
                                <div hidden={item.isHidden}>
                                    <Picker
                                        data={areaList.length == 0 ? defultCityData() : configCityData()}
                                        cols={1}
                                        className="forss"
                                        value={cityName}
                                        onChange={(v: any) => onCity(v)}
                                        disabled={item.disabled}
                                    >
                                        <List.Item
                                            arrow={'horizontal'}
                                            extra={item.placeholder}
                                        ></List.Item>
                                    </Picker>
                                </div>
                            }

                            {/* 性别下拉 */}
                            {item.key == 'Picker-sex' &&
                                <Picker
                                    data={sexList}
                                    cols={1}
                                    className="forss"
                                    value={sex}
                                    onChange={(v: any) => onSex(v)}
                                >
                                    <List.Item
                                        arrow={'horizontal'}
                                        extra={item.placeholder}
                                    ></List.Item>
                                </Picker>
                            }

                            {/* 助理类型下拉 */}
                            { item.key == 'Picker-assistant' &&
                                <Picker
                                    data={assistantList}
                                    cols={1}
                                    className="forss"
                                    value={assistant}
                                    onChange={(v: any) => onAssistant(v)}
                                >
                                    <List.Item
                                        arrow={'horizontal'}
                                        extra={item.placeholder}
                                    ></List.Item>
                                </Picker>
                            }

                        </div>

                    ))
                }

            </div>

            <div className={styles.btn}>
                <Button
                    color='primary'
                    style={{
                        backgroundColor: '#14C2C3',
                        borderColor: '#14C2C3'
                    }}
                    onClick={submitData}
                >
                    完成
                </Button>
            </div>

            <div className={styles.btn}>
                <Button
                    color='primary'
                    fill='outline'
                    style={{
                        color: '#14C2C3',
                        borderColor: '#14C2C3'
                    }}
                    onClick={toNavigateBack}
                >
                    返回
                </Button>
            </div>

        </div>
    )

}

export default DoctorComplete;